import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MgsFieldDefaultComponent } from './mgs-field-default.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';

@Component({
  selector: 'mng-mgs-field-list-component-name',
  imports: [MatRadioGroup, MatRadioButton, ReactiveFormsModule],
  template: `
    <mat-radio-group [attr.id]="definition.id" [formControl]="formControl" class="group-container">
      @for (tabelleItem of attribut.attributTabelleList; track tabelleItem.id; let i = $index) {
        <mat-radio-button [value]="tabelleItem.id.toString()">
          <div class="text" style="font-weight: 300; white-space: normal; font-size: small">
            {{ tabelleItem.label }}
          </div>
        </mat-radio-button>
      }
    </mat-radio-group>
  `,
  styleUrl: './mgs-field-list.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsFieldListComponent extends MgsFieldDefaultComponent {
  constructor() {
    super();
  }
}
